import { IGetEstatisticasChecklistServicoUseCase } from "../../../presentation/useCases/read/get_estatisticas_checklist_servico_use_case";
import { EstatisticasChecklistServico } from "../../models/estatisticas_checklist_servico";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetEstatisticasChecklistServicoUseCase
 */

export class GetEstatisticasChecklistServicoUseCase implements IGetEstatisticasChecklistServicoUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async getEstatisticasChecklistServico(
    idChecklistServico: number | undefined,
  ): Promise<EstatisticasChecklistServico> {
    if (idChecklistServico === undefined) throw new Error('Falha ao obter id de checklist de serviço!');
    return await this.repository.getEstatisticasChecklistServico(
      idChecklistServico,
    );
  }
}
